import { useEffect, useMemo, type ReactNode } from "react";
import type { Dictionary } from "@/domain/dictionary";
import type { Arena } from "@/domain/types";
import { I18nContext } from "./context";
import { createTranslator } from "./translator";

interface I18nProviderProps {
  language: string;
  dictionary: Dictionary | null;
  arenas: Arena[] | null;
  children: ReactNode;
}

export function I18nProvider({ language, dictionary, arenas, children }: I18nProviderProps) {
  const translator = useMemo(
    () => createTranslator({ language, dictionary, arenas }),
    [language, dictionary, arenas],
  );

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  return <I18nContext.Provider value={translator}>{children}</I18nContext.Provider>;
}
